import { render, staticRenderFns } from "./SuccessfulBidders.vue?vue&type=template&id=7d71a7bc&"
import script from "./SuccessfulBidders.vue?vue&type=script&lang=js&"
export * from "./SuccessfulBidders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d71a7bc')) {
      api.createRecord('7d71a7bc', component.options)
    } else {
      api.reload('7d71a7bc', component.options)
    }
    module.hot.accept("./SuccessfulBidders.vue?vue&type=template&id=7d71a7bc&", function () {
      api.rerender('7d71a7bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/successfulBidder/views/SuccessfulBidders.vue"
export default component.exports